<template>
  <CRow>
    <template v-for="meta in uiMeta">
      <CCol 
        v-if="!meta.invisible"
        :key="meta.key"
        :class="meta._classes && meta._classes.length > 0 ? meta._classes.join(' ') : 'col-12'"
      >
        <div
          v-if="meta.input_type === 'CodeHtmlTextInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <HtmlTextBox 
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            :value="tmpData[meta.key]"
            :readOnly="!meta.editable"
            @input="value => onCodeChange(meta.key, value)"
          />
          <label v-if="meta.editable && meta.placeholder" style="color: #999;">{{meta.placeholder}}</label>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'CodeHtmlInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <CodeEditor
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            :value="tmpData[meta.key]"
            language="html"
            :readOnly="!meta.editable"
            @input="value => onCodeChange(meta.key, value)"
          />
          <label v-if="meta.editable && meta.placeholder" style="color: #999;">{{meta.placeholder}}</label>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'CodeYamlInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <CodeEditor
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            :value="tmpData[meta.key]"
            language="yaml"
            :readOnly="!meta.editable"
            @input="value => onCodeChange(meta.key, value)"
          />
          <label v-if="meta.editable && meta.placeholder" style="color: #999;">{{meta.placeholder}}</label>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'CodeCssInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.Key">{{meta.label}}</label>
          <CodeEditor
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            :value="tmpData[meta.key]"
            language="css"
            :readOnly="!meta.editable"
            @input="value => onCodeChange(meta.key, value)"
          />
          <label v-if="meta.editable && meta.placeholder" style="color: #999;">{{meta.placeholder}}</label>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'CodeJsonInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <CodeEditor
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            :value="tmpData[meta.key]"
            language="json"
            :readOnly="!meta.editable"
            @input="value => onCodeChange(meta.key, value)"
          />
          <label v-if="meta.editable && meta.placeholder" style="color: #999;">{{meta.placeholder}}</label>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'CodeJsInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <CodeEditor
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            :value="tmpData[meta.key]"
            language="js"
            :readOnly="!meta.editable"
            @input="value => onCodeChange(meta.key, value)"
          />
          <label v-if="meta.editable && meta.placeholder" style="color: #999;">{{meta.placeholder}}</label>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
        </div>
        <div 
          v-else-if="meta.input_type === 'DateInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <br/>
          <date-picker
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            style="width: 100%;"
            v-model="tmpData[meta.key]" 
            valueType="format"
            :placeholder="meta.editable ? meta.placeholder : ''"
            :id="meta.key"
            v-on:change="onDatetimeChange(meta.key)"
            :disabled="!meta.editable"
            >
          </date-picker>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
        </div>
        <div 
          v-else-if="meta.input_type === 'DateTimeInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <br/>
          <date-picker
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            style="width: 100%;"
            v-model="tmpData[meta.key]" 
            type="datetime"
            valueType="format"
            :placeholder="meta.editable ? meta.placeholder : ''"
            :id="meta.key"
            v-on:change="onDatetimeChange(meta.key)"
            :format="dateTimeFormat"
            :disabled="!meta.editable"
            >
          </date-picker>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
        </div>
        <div 
          v-else-if="meta.input_type === 'TimeRangeInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <br/>
          <date-picker
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            style="width: 100%;"
            v-model="temporaryModel[meta.key]" 
            format="hh:mm A"
            type="time"
            valueType="HH:mm:ssZ"
            :minute-step="15"
            :placeholder="meta.editable ? meta.placeholder : ''"
            :id="meta.key"
            v-on:change="onTimeRangeChange(meta.key, meta.multiple)"
            :disabled="!meta.editable"
            range
            confirm
          ></date-picker>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
          <br/>
          <CRow>
            <CCol
              v-for="(timeRange, index) in tmpData[meta.key] && tmpData[meta.key].split(',')"
              class="col-12"
              :key="meta.key + '-' + index"
              style="padding-top: 10px;"
            >
                <span
                style="box-shadow: 0 0 1px; width: 100%; padding: 5px; margin-top: 5px;"
                >{{timeRange.split('~')[0].substring(0, 5)}} ~ {{timeRange.split('~')[1].substring(0, 5)}}</span>
                <span 
                  style="cursor: pointer; margin-left: 10px;"
                  @click="onRemoveCommanSeperatedStr(meta.key, index)"
                >X</span>
            </CCol>
          </CRow>
        </div>
        <div 
          v-else-if="meta.input_type === 'DateTimeRangeInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <br/>
          <date-picker
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            style="width: 100%;"
            v-model="temporaryModel[meta.key]" 
            format="YYYY-MM-DD hh:mm A"
            type="datetime"
            :minute-step="15"
            :placeholder="meta.editable ? meta.placeholder : ''"
            :id="meta.key"
            v-on:change="onDateTimeRangeChange(meta.key, meta.multiple)"
            :disabled="!meta.editable"
            range
            confirm
          ></date-picker>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
          <br/>
          <CRow>
            <CCol
              v-for="(timeRange, index) in tmpData[meta.key] && tmpData[meta.key].split(',')"
              class="col-12"
              :key="meta.key + '-' + index"
              style="padding-top: 10px;"
            >
                <span
                style="box-shadow: 0 0 1px; width: 100%; padding: 5px; margin-top: 5px;"
                >{{new Date(timeRange.split('~')[0]).format("yyyy-MM-dd hh:mm")}} ~ {{new Date(timeRange.split('~')[1]).format("yyyy-MM-dd hh:mm")}}</span>
                <span 
                  style="cursor: pointer; margin-left: 10px;"
                  @click="onRemoveCommanSeperatedStr(meta.key, index)"
                >X</span>
            </CCol>
          </CRow>
        </div>
        <div 
          v-else-if="meta.input_type === 'MultiOptionsInput'"
          class="form-group"
        >
          <CInput
            :label="meta.label"
            :placeholder="meta.editable ? meta.placeholder : ''"
            v-model="temporaryModel[meta.key]"
            v-on:blur="onMultiOptionsChange(meta.key)"
            v-on:keyup.enter="onMultiOptionsChange(meta.key)"
            :disabled="!meta.editable"
            :invalid-feedback="validateFeedback[meta.key]"
            :is-valid="validate(meta.key)"
            style="margin-bottom: 0rem;"
          />
          <CRow>
            <CCol
              v-for="(option, index) in tmpData[meta.key] && tmpData[meta.key].split(',')"
              class="col-12"
              :key="meta.key + '-' + index"
              style="padding-top: 10px;"
            >
                <span
                style="box-shadow: 0 0 1px; width: 100%; padding: 5px; margin-top: 5px;"
                >{{option}}</span>
                <span 
                  style="cursor: pointer; margin-left: 10px;"
                  @click="onRemoveCommanSeperatedStr(meta.key, index)"
                >X</span>
            </CCol>
          </CRow>
        </div>
        <div 
          v-else-if="meta.input_type === 'SelectInput' || meta.input_type === 'RadioInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <v-select 
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            v-model="tmpData[meta.key]"
            :options="meta.select_options" 
            :reduce="option => option.value ? option.value : (option.label ? option.label : option)"
            :id="meta.key"
            @input="debounceValidate(meta.key)"
            :disabled="!meta.editable"
            :multiple="meta.multiple"
            :taggable="meta.select_allow_new_input"
            :placeholder="meta.editable ? meta.placeholder : ''"
          />
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
        </div>
        <div 
          v-else-if="meta.input_type === 'ImageInput'"
          class="form-group"
        >
          <label v-if="meta.label" :for="meta.key">{{meta.label}}</label>
          <CButton 
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'is-valid' : 'is-invalid'"
            size="sm"
            color="light"
            style="margin-left: 10px;"
            @click="onSelectImage(meta.key, meta.multiple)"
          >{{i18nMessage.SelectImage}}</CButton>
          <div v-if="validateFeedback[meta.key]" class="invalid-feedback">{{validateFeedback[meta.key]}}</div>
          <br/>
          <CRow style="margin-top: 10px;">
            <CCol
              v-for="(url, index) in tmpData[meta.key] && tmpData[meta.key].split(',')"
              class="col-6 col-sm-3"
              :key="url"
            >
                <img
                  :src="url"
                  style="box-shadow: 0 0 1px; width: 100%;"
                />
                <span 
                  style="cursor: pointer; position: absolute; right: 0px; top: 0px;"
                  @click="onRemoveCommanSeperatedStr(meta.key, index)"
                >X</span>
            </CCol>
          </CRow>
        </div>
        <div 
          v-else-if="meta.input_type === 'PasswordInput'"
          class="form-group"
        >
          <CInput
            type="password"
            :label="meta.label"
            :placeholder="meta.editable ? meta.placeholder : ''"
            v-model="tmpData[meta.key]"
            v-on:input="debounceValidate(meta.key)"
            :disabled="!meta.editable"
            :invalid-feedback="validateFeedback[meta.key]"
            :is-valid="validate(meta.key)"
          />
        </div>
        <div 
          v-else-if="meta.input_type === 'NumberInput'"
          class="form-group"
        >
          <CInput
            type="number"
            :label="meta.label"
            :placeholder="meta.editable ? meta.placeholder : ''"
            v-model.number="tmpData[meta.key]"
            v-on:input="debounceValidate(meta.key)"
            :disabled="!meta.editable"
            :invalid-feedback="validateFeedback[meta.key]"
            :is-valid="validate(meta.key)"
          />
        </div>
        <div 
          v-else-if="meta.input_type === 'MultiLineInput'"
          class="form-group"
        >
          <CTextarea
            :label="meta.label"
            :placeholder="meta.editable ? meta.placeholder : ''"
            v-model="tmpData[meta.key]"
            v-on:input="debounceValidate(meta.key)"
            :disabled="!meta.editable"
            :invalid-feedback="validateFeedback[meta.key]"
            :is-valid="validate(meta.key)"
            :rows="tmpData[meta.key] ? tmpData[meta.key].split('\n').length : 1"
          />
        </div>
        <div 
          v-else
          class="form-group"
        >
          <CInput
            :label="meta.label"
            :placeholder="meta.editable ? meta.placeholder : ''"
            v-model="tmpData[meta.key]"
            v-on:input="debounceValidate(meta.key)"
            :disabled="!meta.editable"
            :invalid-feedback="validateFeedback[meta.key]"
            :is-valid="validate(meta.key)"
          />
        </div>
      </CCol>
    </template>
  </CRow>
</template>

<script>
import { mapState, } from 'vuex'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue-select/dist/vue-select.css'
import CodeEditor from './CodeEditor'
import gql from '../api/gql'
import HtmlTextBox from "./editable/HtmlTextBox";

const uiMetaFieldsFragment = `
    fragment uiMetaFields on VoUiMeta {
      _classes
      input_type
      key
      label
      placeholder
      select_options {
        label
        value
        description
      }
      select_allow_new_input
      editable
      validate_dep_keys
      default_value
      multiple
      invisible
      call_refresh_on_value_change
    }
`

export default {
  name: 'AppForm',
  components: {
    DatePicker,
    vSelect,
    CodeEditor,
    HtmlTextBox,
  },
  props: {
    voName: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      default() { return {} },
    },
  },
  data() {
    const route = this.$router.resolve({ 
      name: 'ImageManager',
    })

    return {
      filebrowserBrowseUrl: route.href,
      dateTimeFormat: {
        stringify: (date) => {
          return date ? date.format("yyyy-MM-dd hh:mm:ss") : ''
        },
        // String to Date
        parse: (value) => {
          return value ? new Date(value) : null
        }
      },
      validateFeedback: {},
      debounceFunc: {},
      tmpData: {},
      temporaryModel: {},
      uiMeta: [],
      uiMetaRefreshKey: '',
      isUiMetaReady: false,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      errors: state => state.errors,
    }),
  },
  methods: {
    popupCenter (url, title, w, h) {
        // Fixes dual-screen position                             Most browsers      Firefox
        const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

        const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        const systemZoom = width / window.screen.availWidth;
        const left = (width - w) / 2 / systemZoom + dualScreenLeft
        const top = (height - h) / 2 / systemZoom + dualScreenTop
        const newWindow = window.open(url, title, 
          `
          scrollbars=yes,
          width=${w / systemZoom}, 
          height=${h / systemZoom}, 
          top=${top}, 
          left=${left}
          `
        )

        if (window.focus) {
          newWindow.focus()
        }
    },
    onSelectImage(key, multiple) {
      const $this = this
      window.UPDATE_IMAGE_ACTION = (url) => {
        if (multiple && $this.tmpData[key]) {
          $this.tmpData[key] = $this.tmpData[key] + "," + url
        } else {
          $this.tmpData[key] = url
        }
        $this.$forceUpdate()
        $this.debounceValidate(key)
        $this.UPDATE_IMAGE_ACTION = null
      }
      this.popupCenter(this.filebrowserBrowseUrl, '_blank', 800, 600)
    },
    onRemoveCommanSeperatedStr(key, index) {
      const urls = this.tmpData[key].split(',')
      urls.splice(index, 1)
      this.tmpData[key] = urls.join(',')
      this.debounceValidate(key)
    },
    onCodeChange (key, value) {
      this.tmpData[key] = value
      this.debounceValidate(key, 5000)
    },
    onDatetimeChange (key) {
      try {
        this.tmpData[key] = new Date(this.tmpData[key]).toISOString()
      } catch (Error) {
        // pass
      }
      this.debounceValidate(key)
    },
    onMultiOptionsChange(key) {
      const value = this.temporaryModel[key]
      if (value) {
        if (this.tmpData[key]) {
          this.tmpData[key] = this.tmpData[key] + ',' + value
        } else {
          this.tmpData[key] = value
        }
        this.temporaryModel[key] = ''
        this.debounceValidate(key)
      }
    },
    onDateTimeRangeChange(key, multiple) {
      const value = this.temporaryModel[key]
      if (value[0] && value[1]) {
        const timeRangeStr = value[0].toISOString() + '~' + value[1].toISOString()
        if (multiple && this.tmpData[key]) {
          this.tmpData[key] = this.tmpData[key] + ',' + timeRangeStr
        } else {
          this.tmpData[key] = timeRangeStr
        }
        this.debounceValidate(key)
      }
    },
    onTimeRangeChange(key, multiple) {
      const value = this.temporaryModel[key]
      if (value[0] && value[1]) {
        const timeRangeStr = value[0] + '~' + value[1]
        if (multiple && this.tmpData[key]) {
          this.tmpData[key] = this.tmpData[key] + ',' + timeRangeStr
        } else {
          this.tmpData[key] = timeRangeStr
        }
        this.debounceValidate(key)
      }
    },
    debounceValidate(fieldName, waitTime) {
      this.emitDataOnChange()
      if (this.debounceFunc[fieldName]) clearTimeout(this.debounceFunc[fieldName])
      this.debounceFunc[fieldName] = setTimeout(() => {
        const valueObject = {}
        valueObject[fieldName] = this.tmpData[fieldName]
        let needToRefresh = false
        for (const element of this.uiMeta) {
          if (element.key === fieldName) {
            if (element.validate_dep_keys) {
              for (const depkey of element.validate_dep_keys) {
                valueObject[depkey] = this.tmpData[depkey]
              }
            }
            needToRefresh = element.call_refresh_on_value_change
            break
          }
        }
        let query = null
        if (needToRefresh) {
          query = {
            query: `
              ${uiMetaFieldsFragment}
              query($voName: String!, $fieldName: String!, $inputForValidate: JSON!, $inputForUpdate: JSON!){
                ValidateField(fieldName: $fieldName, input: $inputForValidate, voName: $voName)
                GetUpdatedUiMetaAndData(name: $voName, input: $inputForUpdate){
                  data
                  ui_meta {
                    ...uiMetaFields
                  }
                }
              }
            `,
            variables: {
              voName: this.voName,
              fieldName: fieldName,
              inputForValidate: valueObject,
              inputForUpdate: this.tmpData
            },
          }
        } else {
          query = {
            query: `
              query($voName: String!, $fieldName: String!, $input: JSON!){
                ValidateField(fieldName: $fieldName, input: $input, voName: $voName)
              }
            `,
            variables: {
              voName: this.voName,
              fieldName: fieldName,
              input: valueObject,
            },
          }
        }
        gql.query(query).then(resp => {
          if (needToRefresh && resp.GetUpdatedUiMetaAndData) {
            this.uiMeta = resp.GetUpdatedUiMetaAndData.ui_meta
            this.tmpData = resp.GetUpdatedUiMetaAndData.data
          }
          Object.keys(resp.ValidateField).forEach(key => {
            this.validateFeedback[key] = resp.ValidateField[key].join(',')
          })
          this.$forceUpdate()
          Object.keys(this.validateFeedback).forEach(key => {
            if (this.validateFeedback[key]) {
              return
            }
          })
        })
      }, waitTime ? waitTime : 1000)
    },
    emitDataOnChange() {
      const obj = {}
      for (const meta of this.uiMeta) {
        if (meta.key in this.tmpData) {
          obj[meta.key] = this.tmpData[meta.key]
        }
      }
      this.$emit('changed', obj)
    },
    validate (fieldName) {
      if (this.validateFeedback[fieldName] === null || this.validateFeedback[fieldName] === undefined) {
        return null
      } else {
        return !this.validateFeedback[fieldName]
      }
    },
    parseDataWithDefaultValue(data) {
      const obj = {}
      for (const element of this.uiMeta) {
        if (element.default_value) {
          obj[element.key] = element.default_value
        }
      }
      return {
        ...obj,
        ...data,
      }
    },
    asyncQueryUpdatedUiMetaAndData(voName, data) {
      return gql.query({
        query: `
          ${uiMetaFieldsFragment}
          query($name: String!, $input: JSON!){
            GetUpdatedUiMetaAndData(name: $name, input: $input){
              data
              ui_meta {
                ...uiMetaFields
              }
            }
          }
        `,
        variables: {
          name: voName,
          input: data,
        },
      })
    },
    generateUiMetaRefreshKey(currentData) {
      const keys = []
      for (const element of this.uiMeta) {
        if (element.call_refresh_on_value_change) {
          keys.push(currentData[element.key] ? currentData[element.key] : '')
        }
      }
      return keys.join(':')
    },
  },
  created () {
    this.asyncQueryUpdatedUiMetaAndData(this.voName, this.data)
      .then(resp => {
        this.uiMeta = resp.GetUpdatedUiMetaAndData.ui_meta
        this.tmpData = this.parseDataWithDefaultValue(resp.GetUpdatedUiMetaAndData.data)
        this.uiMetaRefreshKey = this.generateUiMetaRefreshKey(this.tmpData)
        this.$emit('init', this.tmpData)
        this.isUiMetaReady = true
      })
  },
  destroy () {},
  watch: {
    data (newVal) {
      // Wait to fetch uiMeta
      const $this = this
      function checkUiMetaLock() {
        if ($this.isUiMetaReady) {
          const newUiMetaRefreshKey = $this.generateUiMetaRefreshKey(newVal)
          if (newUiMetaRefreshKey !== $this.uiMetaRefreshKey) {
            $this.isUiMetaReady = false
            $this.asyncQueryUpdatedUiMetaAndData($this.voName, newVal)
              .then(resp => {
                $this.uiMeta = resp.GetUpdatedUiMetaAndData.ui_meta
                $this.tmpData = $this.parseDataWithDefaultValue(resp.GetUpdatedUiMetaAndData.data)
                $this.uiMetaRefreshKey = $this.generateUiMetaRefreshKey(newVal)
                $this.isUiMetaReady = true
              })
          } else {
            $this.tmpData = $this.parseDataWithDefaultValue(newVal)
          }
        } else {
          setTimeout(checkUiMetaLock, 100)
        }
      }
      checkUiMetaLock()
    },
    errors (newVal) {
      const tmpValidateFeedback = {}
      for (const key in newVal.validateFeedback) {
        tmpValidateFeedback[key] = newVal.validateFeedback[key].join(',')
      }
      this.validateFeedback = tmpValidateFeedback
    }
  }
}

</script>

<style>
  .vs__dropdown-toggle {
    margin-top: 1px;
    width: 100%; 
    height: 34px; 
    font-size: 14px; 
    line-height: 1.4;
  }
  .v-select {
    background-color: white;
  }
  .v-select .vs__search {
    color: #768192;
  }
  .v-select .vs__selected {
    color: #768192;
  }
  .is-invalid {
    border: 0.1em solid #e55353;
    border-radius: 5px;
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  }
  .is-invalid:focus {
    border: 0.1em solid #e55353;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #e55353;
  }
  .is-valid {
    border: 0.1em solid #2eb85c;
    border-radius: 5px;
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  }
  .is-valid {
    border: 0.1em solid #2eb85c;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #2eb85c;
  }
</style>